(function () {
  const section = document.currentScript.closest('section');
  const linkElements = section.querySelectorAll('[data-group-links] a');

  linkElements.forEach(function (linkElement) {
    linkElement.addEventListener('click', function (event) {
      const href = linkElement.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      if (window.innerWidth <= 749) return;

      const targetElement = document.querySelector(href);
      if (!targetElement) return;

      event.preventDefault();
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    });
  });
})();